import React from 'react';
import { NavLink } from 'react-router-dom';
import cx from 'classnames';

import { ReactComponent as BellIcon } from 'assets/icons/locals-date/bell.svg';
import { ReactComponent as MessageIcon } from 'assets/icons/locals-date/message.svg';
import { ReactComponent as SearchIcon } from 'assets/icons/locals-date/search.svg';
import { ReactComponent as UserIcon } from 'assets/icons/locals-date/user.svg';
import { ReactComponent as VideoCameraIcon } from 'assets/icons/locals-date/video-camera.svg';

import css from './localsDateBottomNavigationBar.module.sass';

interface Props {
  isHasNewDialogs: boolean;
  isHasNewNotifications: boolean;
  isVideoIconHide: boolean;
}

export const LocalsDateBottomNavigationBar: React.FC<Props> = ({
  isHasNewDialogs,
  isHasNewNotifications,
  isVideoIconHide,
}) => {
  return (
    <nav className={css.root}>
      <ul className={css.list}>
        <li className={css.item}>
          <NavLink
            to="/finder"
            exact
            className={css.link}
            activeClassName={css.linkStateActive}
          >
            <SearchIcon className={cx(css.icon, css.iconTypeSearch)} />
          </NavLink>
        </li>
        {!isVideoIconHide && (
          <li className={css.item}>
            <NavLink
              to="/finder/videocast"
              exact
              className={css.link}
              activeClassName={css.linkStateActive}
            >
              <VideoCameraIcon className={cx(css.icon, css.iconTypeCamera)} />
            </NavLink>
          </li>
        )}
        <li className={css.item}>
          <NavLink
            to="/threads"
            exact
            className={cx(css.link, {
              [css.linkStateNotification]: isHasNewDialogs,
            })}
            activeClassName={css.linkStateActive}
          >
            <MessageIcon className={cx(css.icon, css.iconTypeMessage)} />
          </NavLink>
        </li>
        <li className={css.item}>
          <NavLink
            to="/notifications"
            exact
            className={cx(css.link, {
              [css.linkStateNotification]: isHasNewNotifications,
            })}
            activeClassName={css.linkStateActive}
          >
            <BellIcon className={cx(css.icon, css.iconTypeBell)} />
          </NavLink>
        </li>
        <li className={css.item}>
          <NavLink
            to="/myprofile"
            exact
            className={css.link}
            activeClassName={css.linkStateActive}
          >
            <UserIcon className={cx(css.icon, css.iconTypeUser)} />
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};
